module.exports = __webpack_public_path__ + "img/logo_Phoi.d22bf5fc.png";